import React from "react"
import { Row, Col, Table, Button } from "reactstrap"
import { useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
//redux
const MaterialSupplierDelete = props => {
  const { t } = useTranslation()
  // eslint-disable-next-line react/prop-types
  const { selectRows, handleDelete, handleClose } = props
  return (
    <>
      <h5>
        <strong>{t("global:messageDelete")}</strong>
      </h5>

      <Table striped>
        <thead>
          <tr>
            <th>{t("materialSupplier:nroFile")}</th>
            <th>{t("materialSupplier:titleNameMaterial")}</th>
            <th>{t("materialSupplier:titleCodeSap")}</th>
            <th>{t("materialSupplier:titleDescription")}</th>
            <th>{t("materialSupplier:titleSupplier")}</th>
          </tr>
        </thead>
        <tbody>
          {selectRows?.map((row, index) => (
            <tr key={index}>
              <th scope="row">{row.id}</th>
              <td>{row.name}</td>
              <td>{row.codeSap}</td>
              <td>{row.description}</td>
              <td>{row.supplier.name}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Row>
        <Col>
          <div className="modal-footer">
            <Button color="danger" onClick={handleDelete}>
              {t("global:delete")}
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              {t("global:exit")}
            </Button>
          </div>
        </Col>
      </Row>
    </>
  )
}
export default withRouter(MaterialSupplierDelete)
